import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { BodegaService } from 'src/app/services/bodega.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { MovimientoStockService } from 'src/app/services/movimiento-stock.service';
import { ProductoService } from 'src/app/services/producto.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { debounceTime, filter } from 'rxjs/operators';
import * as _ from 'lodash'
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { DatesService } from 'src/app/shared/services/dates.service';

@Component({
  selector: 'app-saldo-sku-mes',
  templateUrl: './saldo-sku-mes.component.html',
  styleUrls: ['./saldo-sku-mes.component.scss'],
  providers: [SecurityService],
})
export class ReporteInventarioSaldoSKUMesComponent implements OnInit {

  // Modales
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent

  // Form
  formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  private currentPayload: any = null
  optionsBodega: Array<any> = [];
  optionsMonth: Array<any> = [];
  optionsYear: Array<any> = [];
  loading: boolean = false
  listaMovimientos: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  productoSeleccionado: any = null

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private bodegaService: BodegaService,
    private productoService: ProductoService,
    private movimientoStockService: MovimientoStockService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('SALDO-SKU-MES')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10

    this.loadBodegas()
    this.loadMonths()
    this.loadYears()

    this.createForm()
    this.formChangesSubscriptions()
    this.setDefaults()
  }

  loadMonths() {
    this.optionsMonth = this.datesService.GetCurrentMonths('desc')
  }

  loadYears() {
    this.optionsYear = this.datesService.GetLastYears()
  }

  private createForm() {
    this.formHeader = this.fb.group({
      bodega: [[]],
      mes: [null],
      anho: [null],
      sku: [null]
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get("sku").valueChanges
      .pipe(filter(Boolean), debounceTime(500))
      .subscribe((codigo: string) => {
        this.modalSeleccionarProducto.searchBySKU(codigo)
      })
  }

  private loadBodegas() {
    this.bodegaService.GetBodegas(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsBodega = registros.map(bodega => ({ value: bodega.codigo, label: bodega.nombre, sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo }))
    })
  }

  setDefaults() {
    if (this.optionsMonth.length > 0)
      this.formHeader.get('mes').setValue(this.optionsMonth[0].value)
    if (this.optionsYear.length > 0)
      this.formHeader.get('anho').setValue(this.optionsYear[0].value)
  }

  openModalSeleccionarProducto() {
    this.modalSeleccionarProducto.show()
  }

  onProductoSeleccionado({ data: _productoSeleccionado }) {
    this.productoSeleccionado = _productoSeleccionado
    this.formHeader.get('sku').setValue(_productoSeleccionado.sku)
  }

  onProductoNoEncontrado() {
    this.productoSeleccionado = null
  }

  buscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.paginationContext.CurrentPage = pageNumber

    this.listaMovimientos = null

    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        sku: this.formHeader.get('sku').value ? this.formHeader.get('sku').value : '',
        listaBodega: this.formHeader.get('bodega').value,
        mes: this.formHeader.get('mes').value,
        anno: this.formHeader.get('anho').value,
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.currentPayload = _.cloneDeep(inputParams)

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.movimientoStockService.obtenerSaldoXSkuXMes(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaMovimientos = registros
      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  exportarExcel() {
    const inputParams = _.cloneDeep(this.currentPayload)
    inputParams.entidad.retornaExcel = true
    delete inputParams.paginaActual
    delete inputParams.cantidadRegistrosPorPagina

    this.log('XLS', JSON.stringify(inputParams))

    this.movimientoStockService.obtenerSaldoXSkuXMesExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }
}
